export default __webpack_public_path__ + "static/media/Invite_Template.a0abdea0.csv";